import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CardAccentConfig, CardAction, CardItem } from './card.model';


@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css',
})
export class CardComponent {
  title = input('');
  description = input('');
  status = input('');
  statusConfig = input<Record<string, { color?: string; background?: string }>>({});
  accentByStatus = input<CardAccentConfig>({});
  items = input<CardItem[]>([]);
  actions = input<CardAction[]>([]);

  getStatusStyle(): Record<string, string> | null {
    const config = this.statusConfig()[this.status()];
    if (!config) return null;
    const style: Record<string, string> = {};
    if (config.color) style['color'] = config.color;
    if (config.background) style['background'] = config.background;
    return Object.keys(style).length > 0 ? style : null;
  }

  getStatusClass(): string {
    return this.status() ? `status-${this.status().toLowerCase().replace(/\s+/g, '-')}` : '';
  }

  getAccentColor(): string | null {
    return this.accentByStatus()[this.status()] ?? null;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
